import {usePanels} from '../../contexts';
import {useSignalValue} from '../../hooks';
import {EditorPanel} from '../../signals';
import {
  Cascade,
  Settings,
  Videocam,
} from '../icons';
import {Space, Tab, TabGroup, TabLink, Tabs} from '../tabs';
import styles from './Navigation.module.scss';
import {ProjectSwitcher} from './ProjectSwitcher';

function Sparkles() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3L14.5 8.5L20 12L14.5 15.5L12 21L9.5 15.5L4 12L9.5 8.5L12 3Z" />
    </svg>
  );
}

export function Navigation() {
  const {tabs, sidebar} = usePanels();
  const sidebarTab = useSignalValue(sidebar.current);

  return (
    <Tabs className={styles.root}>
      <ProjectSwitcher />
      <TabLink
        title="Project Selection"
        id="project-selection-link"
        href={window.location.pathname === '/' ? undefined : '../'}
      >
        <Cascade />
      </TabLink>
      <TabGroup tab={sidebarTab} setTab={tab => sidebar.set(tab)}>
        <Tab
          title="Video Settings"
          id="rendering-tab"
          tab={EditorPanel.VideoSettings}
        >
          <Videocam />
        </Tab>
        <Tab
          title="AI Assistant"
          id="threads-tab"
          tab={EditorPanel.Threads}
        >
          <Sparkles />
        </Tab>
        {/* eslint-disable-next-line @typescript-eslint/naming-convention */}
        {tabs.map(({name, tabComponent: Component}) => (
          <Component key={name} tab={name} />
        ))}
        <Tab title="Settings" id="settings-tab" tab={EditorPanel.Settings}>
          <Settings />
        </Tab>
      </TabGroup>
      <Space />
    </Tabs>
  );
}
